import {SET_USER, FETCH_USER, SET_LOGIN_FAILED} from "./constants";
import AuthService from "../../../_services/auth-service";
import {globalCatch} from "../../../_services/global-catch";
import { CompanyLoginPostRequest} from "../../../_api";
import {fetchCompany} from "../../jobs/actions";

export const fetchIsLoggedIn = () => {
    return globalCatch.catch(async (dispatch:any) => {

        // null if not logged in
        const user = await AuthService.instance().isLoggedIn();

        if(user) {
            dispatch(setUser(user));
            dispatch(fetchCompany());
        }
        else {
            dispatch(setLoginFailed());
        }

    });
};


export const doLogin = (login: any) => {
    return globalCatch.catch(async (dispatch:any) => {

        const user = await AuthService.instance().authenticate(login);

        if(user) {
            dispatch(setUser(user));
            dispatch(fetchCompany());
        }
        else {
            dispatch(setLoginFailed());
        }
    });
};

export const fetchUser = () => {
    return globalCatch.catch(async (dispatch:any) => {
        const user = await AuthService.instance().isLoggedIn();
        dispatch(setUser(user));
    });
};

export const recoverPassword = (email:string) => {
    return globalCatch.catch(async (dispatch:any) => {
        await AuthService.instance().recoverPassword(email);
    });
};

export const resetPassword = (token:string, password:string) => {
    return globalCatch.catch(async (dispatch:any) => {
        await AuthService.instance().resetPassword(token, password);
    });
};



export const logout = () => {
    return globalCatch.catch(async (dispatch:any) => {

        dispatch(setUser(null));

        try{await AuthService.instance().signout();}catch(e){console.log(e)}

    });
};

export const setLoginFailed = () => ({type: SET_LOGIN_FAILED});

export const setUser = (payload:any) => ({type: SET_USER, payload});
